import React from "react";
import { SideDrawer, XIcon } from "staysure-component-library";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import useWindowSize from "@/hooks/use-window-size/use-window-size";
import { useWizardTranslation } from "@/libs/i18n/use-wizard-translation";
import { ComparisonTableAreaContentType } from "@/schema/quote-page/page.schema";

import Styles from "./comparison-table-cell.module.css";
import QuoteComparisionTable from "./quote-comparison-table";

type QuoteSideDrawerProps = {
  drawerTitle: string;
  comparisonTableCloseCta?: string;
  selectedTab: string;
  isOpen: boolean;
  setOpen: (value: boolean) => void;
  drawerData: ComparisonTableAreaContentType;
};

export default function ComparisionSideDrawer({
  drawerTitle,
  comparisonTableCloseCta,
  selectedTab,
  drawerData,
  isOpen,
  setOpen,
}: Readonly<QuoteSideDrawerProps>) {
  const windowSize = useWindowSize();
  const { t } = useWizardTranslation();
  return (
    <div data-testid="comparision-side-drawer-wrapper-test-id">
      <SideDrawer
        wrapperStyles="rounded-l-2xl"
        drawerContentWrapperClassName="md:p-spacing-xxl sm:py-spacing-xl sm:px-spacing-l bg-surface-neutral-option-2 flex justify-center"
        drawerContentClassName="sm:w-[312px] md:w-[408px]"
        isOpen={isOpen}
        onCloseDrawer={() => {
          setOpen(false);
        }}
        width={windowSize && windowSize >= 600 ? 504 : "100%"}
        closeBtnWrapperStyles="grid justify-items-end md:mb-spacing-l sm:mb-spacing-m hidden"
        closeButton={<div />}
      >
        <div className="flex justify-end pb-spacing-m">
          <LabelButtonWrapper
            data-testid="comparison-side-drawer-close-button"
            id="comparison-side-drawer-close-button"
            type="button"
            hierarchy="tertiary"
            label={comparisonTableCloseCta ?? t("close", "Close")}
            onClick={() => {
              setOpen(false);
            }}
            isRightIcon
            rightIcon={<XIcon stroke="#306582" />}
            className={`text-[18px] font-body-font
          !px-spacing-xxs leading-[18px] h-[24px] text-border-accent-1-primary font-[600] hover:text-surface-neutral-option-1 ${Styles.closeBtn}`}
          />
        </div>
        <QuoteComparisionTable
          drawerTitle={drawerTitle}
          selectedTab={selectedTab}
          drawerData={drawerData}
        />
      </SideDrawer>
    </div>
  );
}
